import React, { Component } from 'react'
import ComingSoon from '../components/coming-soon/ComingSoon'
import ConfirmRegisterForm from '../components/register/ConfirmRegister'
import Delivery from '../components/home/Delivery'
import GenericSuccessModal from '../components/success-modal/GenericSuccessModal'
import LoginOrJoin from '../components/login/LoginOrJoin'
import ModalPopup from '../components/common/ModalPopup'
import NoDeliveriesToday from '../components/home/NoDeliveriesToday'
import OrderStatusSidebar from '../components/common/OrderStatusSidebar'
import ReferralSuccessNotification from '../components/community/ReferralSuccessNotification'
import SlackBotSuccessModal from '../components/slack/SlackBotSuccessModal'
import SubscriptionPromotional from '../components/home/SubscriptionPromotional'
import URLSearchParams from 'url-search-params'
import UpdateUserLocationPanel from '../components/location-search/UpdateUserLocationPanel'
import { Box, H5 } from '@foodsby/nutrient'
import FeedbackLink from '../components/home/FeedbackLink'
import { Redirect } from 'react-router-dom'
import { SimpleSpinner } from '../components/common/SimpleSpinner'
import { NoBorderCard } from '../components/common/Layout'
import { YourLocation } from '../components/home/YourLocation'
import { changeSelectedDay } from '../redux/modules/home'
import { confirmPasswordStart } from '../redux/modules/user'
import { connect } from 'react-redux'
import { loadLocationStart } from '../redux/modules/location'
import { loadOrderStart } from '../redux/modules/orderDetail'
import { loadProfileStart } from '../redux/modules/profile'
import { notificationAck } from '../redux/modules/notification'
import { pushAnalyticsEvent } from '../util/gtmUtils'
import { reduxForm } from 'redux-form'
import { selectLocationRoute, noLocationRoute } from '../routes/routes'
import {
  selectCurrentLocationWithAddress,
  selectUserLocationId,
  isSelectedDeliveryDateActive,
} from '../redux/modules/selectors'
import {
  loadDeliveryScheduleStart,
  loadDeliveryScheduleFailure,
  selectDelivery,
} from '../redux/modules/delivery'
import { getDayName } from '../util/dateUtils'

export const ConfirmRegisterContainer = reduxForm({ form: 'confirmpassword' })(
  ConfirmRegisterForm,
)

const LoadDayError = () => (
  <div className="center-xs">
    <h5 className="error center-xs">
      <i className="icon-warning" /> Oops! Something went wrong.
    </h5>
    <p>
      Try refreshing the page or switching between days. If this problem
      persists, please <a href={`/contact`}>contact support</a>
    </p>
  </div>
)

const getRedirect = location => {
  if (location) {
    if (location.locationType === 'GroupOrder') {
      const query = new URLSearchParams()
      const { street, city, state, zip } = location.address
      query.set('address', `${street} ${city}, ${state} ${zip}`)
      return <Redirect to={`${selectLocationRoute.path}?${query.toString()}`} />
    } else if (location.activationDate === null) {
      return <Redirect to={noLocationRoute.path} />
    }
  }
  return null
}

class Home extends Component {
  componentDidMount() {
    const {
      match: {
        params: { locationId },
      },
    } = this.props
    const { isAuthenticated, loadLocationStart } = this.props
    loadLocationStart(locationId)
    this.fetchDeliveries(locationId)
    if (isAuthenticated) {
      this.fetchPageData(locationId)
    }
    pushAnalyticsEvent('Ordering', 'View Deliveries', undefined, locationId)
  }

  componentDidUpdate(prevProps) {
    const { isAuthenticated, loadLocationStart } = this.props
    let {
      match: {
        params: { locationId = 0 },
      },
    } = this.props
    locationId = Number(locationId)
    if (Number(prevProps.match.params.locationId) !== locationId) {
      loadLocationStart(locationId)
      this.fetchDeliveries(locationId)
      this.fetchPageData(locationId, true)
    }
    if (prevProps.isAuthenticated === false && isAuthenticated === true) {
      this.fetchPageData(locationId)
    }
  }

  fetchDeliveries = locationId => {
    const { selectedDate, loadDeliveryScheduleStart } = this.props
    loadDeliveryScheduleStart(locationId, selectedDate)
  }

  fetchPageData = (currentLocationId, forceUpdateCache) => {
    const { isAuthenticated, loadOrderStart, selectedDate } = this.props
    const locationId =
      currentLocationId || Number(this.props.match.params.locationId)
    if (isAuthenticated) {
      loadOrderStart(selectedDate, locationId)
    }
  }

  passwordVisibility() {
    let currentType = document.getElementById('loginPassword')
    currentType.type === 'password'
      ? (currentType.type = 'text')
      : (currentType.type = 'password')
  }

  render() {
    const {
      activationDate,
      changeSelectedDay,
      confirmPasswordError,
      confirmPasswordStart,
      deliveries,
      deliveryError,
      error,
      hasChangedLocation,
      isAuthenticated,
      isCurrentUserLoading,
      isLoadingDeliveries,
      isLocationLoading,
      isSelectedDayActive,
      isWebpSupported,
      loadingNewDay,
      location,
      message,
      notificationAck,
      orders,
      profile,
      selectDelivery,
      selectedDate,
      submitting,
      userLocationId,
    } = this.props
    let {
      friendHasOrdered,
      match: {
        params: { locationId },
      },
    } = this.props
    locationId = Number(locationId)

    const newUser = profile && profile.status !== 'CONFIRMED'
    const redirect = getRedirect(location)
    const changeLocationModal =
      !isCurrentUserLoading &&
      isAuthenticated &&
      !hasChangedLocation &&
      locationId.toString() !== userLocationId.toString() ? (
        <UpdateUserLocationPanel locationId={locationId} />
      ) : null

    const hasOrders = orders && orders.length > 0

    return (
      <div>
        <div className="container ContainerGutters">
          <Box
            className="col-sm-12 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3"
            display="flex"
            flexDirection="column"
          >
            <SlackBotSuccessModal />
            <ReferralSuccessNotification />
            <GenericSuccessModal
              isError={error}
              message={message}
              notificationAck={notificationAck}
            />
            {newUser && (
              <ModalPopup showCancel={false}>
                <ConfirmRegisterContainer
                  confirmPasswordError={confirmPasswordError}
                  onSubmit={confirmPasswordStart}
                  submitting={submitting}
                />
              </ModalPopup>
            )}
            {redirect}
            {changeLocationModal}
            {!deliveryError && isSelectedDayActive && (
              <>
                {!isAuthenticated && (
                  <ModalPopup showCancel={false}>
                    <LoginOrJoin
                      joinTitle="Register to Order"
                      locationId={locationId}
                      loginMessage="Login to see deliveries and get lunch delivered to your office."
                      loginTitle="Login to Order"
                      signupMessage="Sign up to see available restaurants and get lunch delivered to your office."
                    />
                  </ModalPopup>
                )}
                {orders && orders.length === 0 && <SubscriptionPromotional />}
                {loadingNewDay ? null : (
                  <YourLocation
                    mb={16}
                    name={location.deliveryLocationName}
                    orderCount={orders?.length}
                    selectedDate={selectedDate}
                  />
                )}
              </>
            )}
          </Box>
        </div>
        {hasOrders && (
          <Box display="flex" flexDirection="column" mb={48} padding="0">
            <NoBorderCard spinnerActive={isLoadingDeliveries}>
              <div className="container">
                <div className="col-sm-12 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
                  <div className="statusContainer">
                    <OrderStatusSidebar locationId={locationId} />
                  </div>
                </div>
              </div>
            </NoBorderCard>
          </Box>
        )}
        <div className="container ContainerGutters">
          <Box
            className="col-sm-12 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3"
            display="flex"
            flexDirection="column"
            height="100%"
          >
            {!deliveryError ? (
              isSelectedDayActive ? (
                !loadingNewDay ? (
                  <>
                    {/* If location had deliveries show delivery cards or show no delivery screen */}
                    {deliveries && deliveries.length ? (
                      <>
                        {hasOrders && (
                          <H5 mb={16} padding="0px 4px">
                            More options delivering {getDayName(selectedDate)}
                          </H5>
                        )}
                        <Delivery
                          deliveries={deliveries}
                          friendHasOrdered={friendHasOrdered}
                          isSelectedDayActive={isSelectedDayActive}
                          isWebpSupported={isWebpSupported}
                          locationId={locationId}
                          selectDelivery={selectDelivery}
                          selectedDate={selectedDate}
                        />
                      </>
                    ) : (
                      <NoDeliveriesToday selectedDate={selectedDate} />
                    )}
                  </>
                ) : null
              ) : !isLocationLoading && activationDate ? (
                <ComingSoon
                  activationDate={activationDate}
                  isAuthenticated={isAuthenticated}
                  locationId={locationId}
                  onChangeDay={date => changeSelectedDay(date, locationId)}
                />
              ) : (
                <SimpleSpinner />
              )
            ) : (
              <LoadDayError />
            )}
            <Box className="center-xs" marginTop={4}>
              <FeedbackLink />
            </Box>
          </Box>
          {/* End Container */}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { deliveries, isLoadingDeliveries } = state.delivery
  const deliveryError = state.delivery.error
  const { selectedDate, loadingNewDay, loadDeliveriesForLocation } = state.home
  const {
    isAuthenticated,
    isCurrentUserLoading,
    hasChangedLocation,
    currentUser,
    submitting,
    confirmPasswordError,
  } = state.user
  const { isLocationLoading } = state.location
  const location = selectCurrentLocationWithAddress(state)
  const { location: { activationDate } = {} } = state.location
  const userLocationId = selectUserLocationId(state)
  const isSelectedDayActive = isSelectedDeliveryDateActive(state)
  const { profile } = state.profile
  const { orders, loading } = state.orderDetail
  const { isWebpSupported } = state.browser
  const { message, error } = state.notification
  return {
    activationDate,
    confirmPasswordError,
    currentUser,
    deliveries,
    deliveryError,
    error,
    hasChangedLocation,
    isAuthenticated,
    isCurrentUserLoading,
    isLoadingDeliveries,
    isLocationLoading,
    isOrdersLoading: loading,
    isSelectedDayActive,
    isWebpSupported,
    loadDeliveriesForLocation,
    loadingNewDay,
    location,
    message,
    orders,
    profile,
    selectedDate,
    submitting,
    userLocationId,
  }
}

const mapDispatchToProps = {
  changeSelectedDay,
  confirmPasswordStart,
  loadDeliveryScheduleFailure,
  loadDeliveryScheduleStart,
  loadLocationStart,
  loadOrderStart,
  loadProfileStart,
  selectDelivery,
  notificationAck,
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
